<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <form (ngSubmit)="onClickSaveAndClose()" [formGroup]="formGroup" appInvalidControlScroll
          [scrollContainer]="scrollContainer">
        <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">{{ 'workflows.screens.selectBoat.title' | translate }}</h2>
                <button data-test="B-Close-dialog" mat-icon-button (click)="onClickClose()"
                        [attr.aria-label]="'common.closeDialogAria' | translate" type="button">
                    <mat-icon>close</mat-icon>
                </button>
    </mat-toolbar>

        <div mat-dialog-content #scrollContainer>
            <form-widget-boat-by-person-or-company
                    [parentFormGroup]="formGroup"></form-widget-boat-by-person-or-company>
        </div>

        <div mat-dialog-actions class="m-0 p-8 p-sm-16" fxLayout="row" fxLayoutAlign="space-between center">

            <button data-test="B-Abbrechen" mat-flat-button (click)="onClickClose()" type="button">
                {{ 'common.cancel' | translate }}
            </button>

            <button type="submit" data-test="B-Übernehmen" mat-flat-button color="accent">
                <mat-icon>checkmark</mat-icon>
                <span>{{ 'common.apply' | translate }}</span>
            </button>

        </div>
    </form>
</div>
